var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card-deck multi-select" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("div", [
          _vm.groups.length > 0
            ? _c(
                "ul",
                { staticClass: "multi-select-filter list-unstyled mb-0" },
                [
                  _c("custom-filter-component", {
                    attrs: {
                      changeFilter: _vm.changeGroup,
                      config: _vm.filterConfig
                    }
                  })
                ],
                1
              )
            : _c("div", { staticClass: "card-header-title" }, [
                _c("b", [_vm._v("Available")])
              ]),
          _vm._v(" "),
          _c("input", {
            staticClass: "form-control float-right",
            staticStyle: { width: "40%" },
            attrs: {
              type: "search",
              placeholder: "Search...",
              role: "combobox"
            },
            on: { input: _vm.filterUnselected }
          })
        ])
      ]),
      _vm._v(" "),
      _vm.initialized
        ? _c(
            "div",
            { staticClass: "list-group" },
            _vm._l(_vm.filteredUnselected, function(item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "list-group-item list-group-item-action"
                },
                [
                  _c("span", { staticClass: "list-group-item-label" }, [
                    _vm._v(
                      _vm._s(_vm.__(item.fullname || item.name, ["titleCase"]))
                    )
                  ]),
                  _vm._v(" "),
                  _vm._.includes(_vm.unselectedProcessingIds, item.id)
                    ? _c(
                        "button",
                        {
                          class: [
                            "btn",
                            "btn-light",
                            "btn-rounded",
                            "btn-sm",
                            "float-right_",
                            "btn-arrow"
                          ],
                          attrs: { type: "button", disabled: "" }
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("more_horiz")
                          ])
                        ]
                      )
                    : _c(
                        "button",
                        {
                          class: [
                            "btn",
                            "btn-light",
                            "btn-rounded",
                            "btn-sm",
                            "float-right_",
                            "btn-arrow"
                          ],
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.select(item)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("arrow_forward")
                          ])
                        ]
                      )
                ]
              )
            }),
            0
          )
        : _c(
            "div",
            { staticStyle: { margin: "3rem auto" } },
            [_c("vue-spinner")],
            1
          )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card" },
      [
        _c("div", { staticClass: "card-header" }, [
          _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control float-right",
              staticStyle: { width: "40%" },
              attrs: {
                type: "search",
                placeholder: "Search...",
                role: "combobox"
              },
              on: { input: _vm.filterSelected }
            })
          ])
        ]),
        _vm._v(" "),
        _c(
          "draggable",
          {
            staticClass: "list-group",
            attrs: { options: { disabled: !_vm.priorityField } },
            on: { end: _vm.changePriority },
            model: {
              value: _vm.selected,
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          },
          _vm._l(_vm.filteredSelected, function(item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "list-group-item list-group-item-action",
                attrs: { href: "javascript:void(0)", target: "_self" }
              },
              [
                _vm.priorityField
                  ? _c("i", { staticClass: "material-icons drag-icon" }, [
                      _vm._v("view_headline")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "list-group-item-label" }, [
                  _vm._v(
                    _vm._s(_vm.__(item.fullname || item.name, ["titleCase"]))
                  )
                ]),
                _vm._v(" "),
                _vm._.includes(_vm.selectedProcessingIds, item.id)
                  ? _c(
                      "button",
                      {
                        class: [
                          "btn",
                          "btn-light",
                          "btn-rounded",
                          "btn-sm",
                          "float-right",
                          "btn-arrow"
                        ],
                        attrs: { type: "button", disabled: "" }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("more_horiz")
                        ])
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-light btn-rounded btn-sm float-right_ btn-arrow",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.deselect(item)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("arrow_back")
                        ])
                      ]
                    )
              ]
            )
          }),
          0
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header-title" }, [
      _c("b", [_vm._v("Selected")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fb2cd3b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fb2cd3b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/MultiSelectComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0fb2cd3b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/MultiSelectComponent.vue
// module chunks = 0